import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import memoize from 'memoize-one';
import translate from '../../translate';
import { LoadCountriesDetails } from '../../../store/countriesDetailsSlice';

const SUPPLEMENTARY_LINE_1 = 'supplementary_line1';
const SUPPLEMENTARY_LINE_2 = 'supplementary_line2';
const SUPPLEMENTARY_LINE_3 = 'supplementary_line3';

const TEMPLATE_REGEX = /{{([\w_]+)}}/g;

const MAP_FIELD_NAMES = {
    company_name: 'company',
    supplementary_line_1: SUPPLEMENTARY_LINE_1,
    supplementary_line_2: SUPPLEMENTARY_LINE_2,
    supplementary_line_3: SUPPLEMENTARY_LINE_3,
    street_and_house_number: 'street_and_housenumber',
};

function mapFieldNames(input) {
    const value = String(input).toLowerCase();
    const resolvedValue = MAP_FIELD_NAMES[value];
    if (resolvedValue) {
        return resolvedValue;
    }
    return value;
}

const ContactAddressPreview = createReactClass({
    displayName: 'ContactAddressPreview',

    propTypes: {
        contactData: PropTypes.shape({
            email: PropTypes.string,
            phone: PropTypes.string,
            company: PropTypes.string,
            [SUPPLEMENTARY_LINE_1]: PropTypes.string,
            [SUPPLEMENTARY_LINE_2]: PropTypes.string,
            name: PropTypes.string,
            street_and_housenumber: PropTypes.string,
            city: PropTypes.string,
            postal_code: PropTypes.string,
            country: PropTypes.string,
        }),
        strings: PropTypes.shape({
            description: PropTypes.string.isRequired,
        }).isRequired,
        contractualCountryId: PropTypes.number.isRequired,
        LoadCountriesDetails: PropTypes.func.isRequired,
        countriesData: PropTypes.shape({
            countries_details: PropTypes.shape({}).isRequired,
        }),
    },

    getDefaultProps() {
        return {
            contactData: undefined,
            countriesData: { countries_details: {} },
        };
    },

    componentDidMount() {
        this.props.LoadCountriesDetails();
    },

    getAddressLines() {
        const data = this.props.countriesData || {};
        const countriesDetails = data.countries_details || {};

        return this.calculateAddressLines(
            countriesDetails,
            this.props.contractualCountryId,
            this.props.contactData
        );
    },

    calculateAddressLines: memoize(
        (countriesDetails, countryId, contactData) => {
            if (!contactData) {
                return [];
            }
            const country = Object.entries(countriesDetails).find(
                (it) => it[1].country_id === countryId
            );

            if (!country) {
                return [];
            }

            const addressTemplate = country[1].country_address_template;
            const address = addressTemplate.replace(
                TEMPLATE_REGEX,
                (str, p) => contactData[mapFieldNames(p)] || ''
            );

            return address.split('\n');
        }
    ),

    render() {
        const addressLines = this.getAddressLines();

        return (
            <div>
                <h3>{this.props.strings.description}</h3>
                <div
                    style={{
                        width: '100%',
                        border: 'rgba(0,0,0,0.2) solid 1px',
                    }}
                >
                    {addressLines.map(
                        (it, i) => it && <div key={`line-${i}`}>{it}</div>
                    )}
                </div>
            </div>
        );
    },
});

export default connect(
    (store) => ({
        countriesData: store.countriesDetails.countriesDetails,
    }),
    { LoadCountriesDetails }
)(translate('ContactAddressPreview')(ContactAddressPreview));
